import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { createTranslateLoader } from '../../http-loader-factory';
import { ScenarioItemComponent } from './scenario-item.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LoaderModule } from '../../components/loader/loader.module';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  UploadFileWithProgressModule
} from '../../../admin/components/upload-file-with-progress/upload-file-with-progress.module';
import { MatTabsModule } from '@angular/material/tabs';
import { CustomPipeModule } from '../../pipes/custom-pipe.module';
import { MatChip } from '@angular/material/chips';
import { MatChipsModule } from '@angular/material/chips';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [ScenarioItemComponent],
  exports: [ScenarioItemComponent],
  imports: [
    UploadFileWithProgressModule,
    AngularSvgIconModule,
    CommonModule,
    MatMenuModule,
    MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatButtonModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSlideToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    LoaderModule,
    MatTabsModule,
    CustomPipeModule,
    MatChipsModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    MatChip,
  ],
})
export class ScenarioItemModule {}
